export enum CutoutTypes{
    none = 'none',
    shape = 'shape',
    text = 'text',
    dxf = 'dxf',
}